import { useSelector } from 'react-redux';

export const useIsMobile = () => {
	const width = useSelector((s: { width: number }) => s.width);

	return width < 768;
};
